'use strict';

module.exports = require('./es2015');



//////////////////
// WEBPACK FOOTER
// ./~/es-to-primitive/es6.js
// module id = 472
// module chunks = 35783957827783